<template>
  <section id="card-text-alignment">
    <b-card title="Filtros">
      <b-row class="filters-row">
        <b-col cols="2">
          <b-form-group
              label="NÚMERO NF:"
              label-for="numero-nf"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon=""/>
              </b-input-group-prepend>
              <b-form-input
                  id="numero-nf"
                  type="text"
                  v-model="numero_nf"
                  placeholder="Número NF"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
              label="SITUAÇÃO:"
              label-for="situacao"
          >

            <b-form-select
                id="situacao"
                v-model="selected"
                :options="options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
              label="DE:"
              label-for="de"
          >
            <b-form-datepicker
                id="datepicker-default-1"
                v-model="de"
                local="pt-BR"
                class="mb-2"
                today-variant="danger"
                placeholder="dd/mm/aaaa"
                hide-header
                dark
                date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                weekday-header-format="narrow"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
              label="ATÉ:"
              label-for="ate"
          >
            <b-form-datepicker
                id="datepicker-default-2"
                v-model="ate"
                local="pt-BR"
                class="mb-2"
                today-variant="danger"
                placeholder="dd/mm/aaaa"
                hide-header
                dark
                date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                weekday-header-format="narrow"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-button-group>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                @click="filters('filter')"
            >
              Filtrar
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="limpar()"
            >
              Limpar
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <br>
      <b-table
          :striped="true"
          :bordered="true"
          :hover="true"
          :responsive="true"
          table-variant="secondary"
          :fields="camposVisiveis"
          :items="getBoletos"
          :busy="getIsLoading"
          small
          show-empty
          empty-text="Nenhum boleto encontrado"
      >
        <!-- A virtual column -->
        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #cell(banco_nome)="data">
          {{ data.value || 'N/A' }}
        </template>

        <template #cell(titulodtvencimento)="data">
          {{ (data.value && data.value !== 'Invalid date') ? new Date(data.value).toLocaleDateString('pt-BR') : 'N/A' }}
        </template>

        <template #cell(titulodtliquidacao)="data">
          {{ (data.value && data.value !== 'Invalid date') ? new Date(data.value).toLocaleDateString('pt-BR') : 'N/A' }}
        </template>

        <template #cell(tituloSituacao)="data">
          {{ formatarSituacao(data.value) }}
        </template>

        <template #cell(action)="data">
          <div
              class="d-flex"
              style="gap:5px"
          >
            <b-button
                variant="success"
                size="sm"
                @click="copiarDadosBoleto(data.item)"
                v-b-tooltip.hover
                title="Copiar dados do boleto"
            >
              <feather-icon icon="FileTextIcon"/>
            </b-button>
            <b-button
                variant="primary"
                size="sm"
                v-b-tooltip.hover
                title="Visualizar DANFE + Boleto (PDF único)"
                :disabled="loadingStates[getDanfeKey(data.item)] || !temDadosDanfe(data.item)"
                @click="verDocumento(data.item, 'ver')"
            >
              <span class="d-flex align-items-center">
                <b-spinner v-if="loadingStates[getDanfeKey(data.item)]" small />
                <feather-icon v-else icon="EyeIcon"/>
              </span>
            </b-button>
            <b-button
                variant="outline-success"
                size="sm"
                v-b-tooltip.hover
                title="Baixar DANFE + Boleto (PDF único)"
                :disabled="loadingStates[getDanfeKey(data.item)] || !temDadosDanfe(data.item)"
                @click="verDocumento(data.item, 'pdf')"
            >
              <feather-icon icon="DownloadIcon"/> PDF
            </b-button>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col sm="5" md="4" class="my-1">
          <b-form-group
              label="paginação"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
          >
            <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
                @change="handlePerPageChange"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="7" md="6" class="my-1">
          <b-pagination
              v-model="currentPage"
              :total-rows="pagination.totalItems"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
              @change="handlePageChange"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import { BFormSelect, BSpinner, VBTooltip } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import PTC_BoletosService from '@/services/PTC/PTC_Boletos.service';
import Ripple from 'vue-ripple-directive';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import DocumentoFiscalClient, { baixarBase64, abrirPdfNovaAba } from '@/api/SistemaDKP/documento-fiscal.client';
import { isPerfilClienteAtivo } from '@/libs/perfilCliente';

const PTC_BoletosClient = new PTC_BoletosService();
const documentoFiscalClient = new DocumentoFiscalClient();

export default {
  components: {
    BFormSelect,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      notafiscalnumero: this.$route.params.notafiscalnumero || null,
      fields: [
        { key: 'clienteiderp', label: 'Cliente Erp' },
        { key: 'banco_nome', label: 'Banco' },
        { key: 'titulonumero', label: 'Número Título / NF' },
        { key: 'titulodocumento', label: 'Documento' },
        // Relacionamento NF ↔ pedido: o cliente precisa saber a que pedido/OC
        // o boleto pertence (o backend enriquece via nota fiscal → pedido).
        { key: 'nrPedidoPortal', label: 'Pedido', formatter: (v) => v || '-' },
        { key: 'ocCliente', label: 'OC Cliente', formatter: (v) => v || '-' },
        { key: 'tituloparcela', label: 'Parcela' },
        { key: 'titulodtemissao', label: 'Data Emissão' },
        { key: 'titulovalororiginal', label: 'Valor Original' },
        { key: 'tituloDtVencimento', label: 'Data Vencimento' },
        { key: 'titulodtliquidacao', label: 'Data Liquidação' },
        { key: 'tituloSituacao', label: 'Situação' },
        { key: 'clienterazaosocial', label: 'Razão Social' },
        { key: 'action', label: 'Ações' },
      ],
      items: [],
      selected: this.$route.query.situacao || null,
      options: [
        { value: null, text: '--Selecionar--', disabled: true },
        { value: 'AVENCER', text: 'A Vencer' },
        { value: 'LIQUIDADO', text: 'Liquidado' },
        { value: 'LIQUIDADOPARCIAL', text: 'Liquidado Parcial' },
        { value: 'VENCIDO', text: 'Vencido' },
      ],
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      numero_nf: null,
      de: '',
      ate: '',
      currentFilters: null,
      loadingStates: {},
    };
  },

  methods: {
    // DANFE do boleto — mesma busca da tela de Notas Fiscais (documento-fiscal/
    // danfe-boleto): o título carrega estabelecimento + série + número da NF.
    // Aqui só PDF (visualizar/baixar); o XML fica restrito à tela de Notas.
    getDanfeKey(item) {
      return `${item.estabelecimentoid}-${item.titulonumero}-${item.tituloserie}`;
    },
    temDadosDanfe(item) {
      return !!(item && item.estabelecimentoid && item.tituloserie && item.titulonumero);
    },
    async verDocumento(item, modo) {
      const key = this.getDanfeKey(item);
      this.$set(this.loadingStates, key, true);
      try {
        // Always authorize against the current tenant/user; no session-global PDF cache.
        const docs = await documentoFiscalClient.danfeBoleto({
          estabelecimentoid: item.estabelecimentoid,
          notafiscalserie: item.tituloserie,
          notafiscalnumero: item.titulonumero,
        });
        const numero = String(docs?.notaFiscal || item.titulonumero);
        if (modo === 'pdf') {
          if (!docs?.arquivoPDF) throw new Error('PDF não disponível para esta nota.');
          baixarBase64(docs.arquivoPDF, `danfe_${numero}.pdf`, 'application/pdf');
        } else {
          if (!docs?.arquivoPDF) throw new Error('PDF não disponível para esta nota.');
          abrirPdfNovaAba(docs.arquivoPDF);
        }
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || 'Erro ao buscar a DANFE deste boleto.';
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: msg,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$set(this.loadingStates, key, false);
      }
    },
    formatarSituacao(situacao) {
      if (!situacao) return '';

      const situacaoMap = {
        AVENCER: 'A Vencer',
        LIQUIDADO: 'Liquidado',
        LIQUIDADOPARCIAL: 'Liquidado Parcial',
        VENCIDO: 'Vencido',
      };

      return situacaoMap[situacao] || situacao;
    },

    async copiarTexto(texto) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(texto);
        return;
      }

      const campoTemporario = document.createElement('textarea');
      campoTemporario.value = texto;
      campoTemporario.setAttribute('readonly', '');
      campoTemporario.style.position = 'fixed';
      campoTemporario.style.opacity = '0';
      campoTemporario.style.pointerEvents = 'none';
      document.body.appendChild(campoTemporario);

      try {
        campoTemporario.focus();
        campoTemporario.select();
        campoTemporario.setSelectionRange(0, campoTemporario.value.length);

        if (!document.execCommand('copy')) {
          throw new Error('O navegador recusou a cópia para a área de transferência');
        }
      } finally {
        document.body.removeChild(campoTemporario);
      }
    },

    async copiarDadosBoleto(boleto) {
      try {
        const identificacaoCliente = this.isClienteAtivo
          ? ''
          : `Cliente ERP: ${boleto.clienteiderp || 'N/A'}\n`;
        const razaoSocial = this.isClienteAtivo
          ? ''
          : `\nRazão Social: ${boleto.clienterazaosocial || 'N/A'}`;
        const dadosFormatados = `Dados do Boleto
================
${identificacaoCliente}Banco: ${boleto.banco_nome || 'N/A'}
Número Título: ${boleto.titulonumero || 'N/A'}
Documento: ${boleto.titulodocumento || 'N/A'}
Parcela: ${boleto.tituloparcela || 'N/A'}
Data Emissão: ${boleto.titulodtemissao || 'N/A'}
Valor Original: ${boleto.titulovalororiginal || 'N/A'}
Data Vencimento: ${(boleto.tituloDtVencimento && boleto.tituloDtVencimento !== 'Invalid date') ? boleto.tituloDtVencimento : 'N/A'}
Data Liquidação: ${(boleto.titulodtliquidacao && boleto.titulodtliquidacao !== 'Invalid date') ? boleto.titulodtliquidacao : 'N/A'}
Situação: ${this.formatarSituacao(boleto.tituloSituacao)}${razaoSocial}`;

        await this.copiarTexto(dadosFormatados);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Dados do boleto copiados para a área de transferência',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao copiar dados:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao copiar dados do boleto. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
    async AllBoletos() {
      await PTC_BoletosClient.retornaBoletos({
        page: this.currentPage,
        limit: this.perPage,
      });
    },

    async filters() {
      const query = {};

      if (this.selected !== null) {
        query.tituloSituacao = this.selected;
      }

      if (this.numero_nf !== null && this.numero_nf !== '') {
        query.notafiscalnumero = this.numero_nf;
      }

      if (this.de !== null && this.de !== '' && this.ate !== null && this.ate !== '') {
        query.tituloDtEmissaoDe = this.de;
        query.tituloDtEmissaoAte = this.ate;
      }

      query.page = 1;
      query.limit = this.perPage;

      this.currentFilters = query;

      await PTC_BoletosClient.retornaBoletos(query);
      this.currentPage = 1;
    },

    async limpar() {
      this.selected = null;
      this.numero_nf = null;
      this.notafiscalnumero = null;
      this.de = '';
      this.ate = '';
      this.currentPage = 1;
      this.currentFilters = null;

      this.$router.replace({ name: this.$route.name });

      await PTC_BoletosClient.retornaBoletos({
        page: 1,
        limit: this.perPage,
      });
    },

    async handlePageChange(page) {
      const query = this.currentFilters || {};
      query.page = page;
      query.limit = this.perPage;

      await PTC_BoletosClient.retornaBoletos(query);
      console.log('Boletos após mudança de página:', this.getBoletos);
    },

    async handlePerPageChange(perPage) {
      const query = this.currentFilters || {};
      query.page = 1;
      query.limit = perPage;

      this.currentPage = 1;
      await PTC_BoletosClient.retornaBoletos(query);
    },
  },

  async mounted() {
    if (this.$route.query.situacao) {
      await this.filters();
    } else if (this.notafiscalnumero !== null) {
      this.numero_nf = this.notafiscalnumero;
      const query = {
        notafiscalnumero: this.notafiscalnumero,
        page: 1,
        limit: this.perPage,
      };
      this.currentFilters = query;
      await PTC_BoletosClient.retornaBoletos(query);
    } else {
      await this.AllBoletos();
    }
  },

  computed: {
    ...mapGetters({
      getBoletos: 'PTC_BoletosClient/getBoletos',
      getIsLoading: 'PTC_BoletosClient/getIsLoading',
      pagination: 'PTC_BoletosClient/getPagination',
    }),
    isClienteAtivo() {
      return isPerfilClienteAtivo();
    },
    camposVisiveis() {
      if (!this.isClienteAtivo) return this.fields;
      return this.fields.filter((field) => !['clienteiderp', 'clienterazaosocial'].includes(field.key));
    },
  },

  watch: {
    'pagination.currentPage': function (newVal) {
      this.currentPage = newVal;
    },
    'pagination.perPage': function (newVal) {
      this.perPage = newVal;
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log('teste-1', toParams, previousParams);
        console.log('teste-2', this.$route.params);
      },
    );

    this.$watch(
      () => this.$route.query,
      (newQuery) => {
        if (newQuery.situacao && newQuery.situacao !== this.selected) {
          this.selected = newQuery.situacao;
          this.filters();
        }
      },
    );
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 767.98px) {
  .filters-row > .col-2,
  .filters-row > .col-4 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 0.5rem;
  }

  .filters-row > .col-4:last-child,
  .filters-row > .col-2:last-child {
    margin-bottom: 0;
  }
}
</style>
